// extracted by mini-css-extract-plugin
export default {"root":"IbxWMW","bg":"wgT5qv","arrow":"uohHMn"};